<template>
  <div class="white_box account_card">
    <div
      :class="[
        'account_icon',
        account ? 'connected' : '',
      ]"
    >
      <svg-vue :icon="icon" />
    </div>
    <div
      v-if="!account"
      class="button"
    >
      <primary-anchor
        :href="connectionHref"
        size="md"
      >
        Connect {{ accountName }}
      </primary-anchor>
    </div>
    <div
      v-else
      class="connected_account"
    >
      <h4>{{ accountName }} Connected!</h4>
      <table>
        <tbody>
          <tr
            v-for="(row, index) in connectedData"
            :key="index"
          >
            <td><strong>{{ row.title }}:</strong></td>
            <td>{{ row.value }}</td>
          </tr>
        </tbody>
      </table>
      <small class="change_later">
        *You can change this later
      </small>
    </div>
  </div>
</template>

<script>
import PrimaryAnchor from "../../global/buttons/PrimaryAnchor";
export default {
  components: {
    PrimaryAnchor,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    account: {
      type: [Object, null],
      default: null,
    },
    accountName: {
      type: String,
      required: true,
    },
    connectionHref: {
      type: String,
      required: true,
    },
    connectedData: {
      type: [Object, null],
      required: true,
    }

  }
}
</script>

<style lang="scss" scoped>
.account_card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  height: 300px;
  width: 30%;

  .account_icon {
    height: 60%;
    width: 100%;
    display: flex;
    justify-content: center;

    &.connected {
      height: 50%;
    }

    svg {
      max-height: 100%;
    }
  }

  .button {
    a {
      width: 100%;
    }
  }

  .connected_account {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    min-height: 50%;
    width: 100%;

    h4 {
      color: var(--primary-color);
    }

    table {
      width: 90%;

      tr {
        td {
          padding: 0 .5rem;

          &:last-of-type {
            text-align: center;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            max-width: 130px;
          }
        }
      }
    }

    .change_later {
      color: var(--primary-color);
    }
  }

}
</style>
